export const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

export const validateAmount = (amount) => {
    return amount && amount > 0;
};

export const validateDate = (date) => {
    return date && new Date(date).getTime() > 0;
};

export const validateRequired = (value) => {
    return value && value.toString().trim().length > 0;
};

export const validateDebtForm = (values) => {
    const errors = {};

    if (!validateRequired(values.nguoiVay)) {
        errors.nguoiVay = 'Vui lòng nhập tên người cho vay';
    }

    if (!validateAmount(values.soTien)) {
        errors.soTien = 'Vui lòng nhập số tiền hợp lệ';
    }

    if (!validateDate(values.ngayVay)) {
        errors.ngayVay = 'Vui lòng chọn ngày vay';
    }

    if (!validateDate(values.ngayTra)) {
        errors.ngayTra = 'Vui lòng chọn ngày trả';
    }

    if (!validateRequired(values.mucDich)) {
        errors.mucDich = 'Vui lòng nhập mục đích vay';
    }

    return {
        isValid: Object.keys(errors).length === 0,
        errors
    };
};
